import TextField from "../../../../components/fields/textField/TextField.vue";
import ConfirmPasswordDialog from "../../../../components/dialog/confirmPassword/ConfirmPasswordDialog.vue";
import PerfilService from "../../../../services/PerfilService";
import FormDialog from "../../../../components/dialog/form/FormDialog.vue";
import { AssinaturaMixin } from "@/mixins/assinaturaMixin";
import { SnackbarMixin } from "@/mixins/snackbarMixin";
import {SnackBarModule} from "@/modules/SnackBarModule";


export default {
  name: "DialogFuncionalidades",
  components: {
    TextField,
    ConfirmPasswordDialog,
    FormDialog,
    SnackBarModule
  },
  mixins:[AssinaturaMixin,SnackbarMixin ],
  props: {
    activeDialog: {
      type: Boolean,
      default: false,
    },
    perfilid: {
      required: true,
    },
  },
  data: () => ({
    headers: [
      { text: "Funcionalidade", value: "nome", sortable: false },
      { text: "", value: "atribuir", sortable: false, width: "100" },
    ],
    data: [],
    errors: [],
    cargoTipoSelect:'perfil',
    cargoTipo:null,
    disabled: {
      nome: false,
      funcionalidades: false,
    },
    form: {},
    formValid: true,
    loading: {
      table: false,
    },
    page: 1,
    pageCount: 0,
    itemsPerPage: 10,
    search: "",
    showFormDialog: false,
    activeBtnDialog:false,
    showDialogConfirmPassword: false,
    formConfirmPassword: {
      justificativa:"",
      password:""
    },
    send: {
      function: () => {},
      params: null,
    },

    funcionalidades: [],
  }),

  watch: {
    activeDialog() {
      if (this.perfilid) {
        console.log(this.perfilid);
        console.log(this.form);
        this.showFormDialog = !this.showFormDialog;
        this.initializeForm();
        this.getEditData();
      }
    },
  },

  created() {
    this.getFuncionalidades();
    this.initializeFormConfirmPassword();
    this.initializeForm();
  },

  methods: {
    goTo(path) {
      this.$router.push(path);
    },

    async getEditData() {
      this.page = 1;

      this.disabled.funcionalidades = true;
      const response = await PerfilService.getFuncionaliadesByPerfilId(
        this.perfilid,
      );


      this.form.id_funcionalidade = response.map(
        (funcionalidade) => funcionalidade.id,
      );

      this.form.arrayFuncionalidades = this.form.id_funcionalidade.slice();

      this.disabled.funcionalidades = false;
    },

    async getFuncionalidades() {
      this.loading.table = true;

      const response = await PerfilService.getFuncionalidades();
      this.funcionalidades = await response;
      this.loading.table = false;
    },

    alertTest() {
    },

    initializeForm() {
      this.form = {
        id_funcionalidade: [],
        arrayFuncionalidades: [],
      };
    },

    async changeFuncionalide(id) {
      this.loading.table = true;
      await PerfilService.atribuirFuncionalidadePerfil(
          this.perfilid,
          { id_funcionalidade: id },

      );
      this.loading.table = false;
    },

    async save() {
      this.errors = [];

      let arrayRemovidos = [];
      let arrayAdicionados = [];

      arrayRemovidos = this.form.arrayFuncionalidades.filter(
        (funcionalidade) =>

          !this.form.id_funcionalidade.includes(funcionalidade),
      );

      arrayAdicionados = this.form.id_funcionalidade.filter(
        (funcionalidade) =>
          !this.form.arrayFuncionalidades.includes(funcionalidade),
      );

      let response = {};
      if (arrayRemovidos.length > 0) {
        response = await PerfilService.removerFuncionalidadePerfil(
          this.perfilid,
          { id_funcionalidade: arrayRemovidos },
        );
      }

      if (!response.error && arrayAdicionados.length > 0) {
        response = await PerfilService.atribuirFuncionalidadePerfil(
          this.perfilid,
          { id_funcionalidade: arrayAdicionados },
        );
      }

      if (!response.error) {
        SnackBarModule("As funcionalidades do perfil foram atualizadas com sucesso","success");
        this.showFormDialog = !this.showFormDialog;
      } else {
        const message = await response.response;
        SnackBarModule(message, "error");
        this.errors.push(message);
      }
    },
  },
};
